import React, { useContext } from "react";
// import { SocialMediaPageContext } from "../../store/SocialMediaPageContext";
import { SocialMediaPageContext } from "../../store/SocilaMediaPageContext";
import { LanguageContext } from '../LanguageContext/LanguageContext';
import styles from "./SocialMediaHeroPage.module.css";

export default function SocialMediaHeroPage({ firstData }) {
  const { direction } = useContext(LanguageContext);
  const isRTL = direction === 'rtl';



  // Extract mediaContent from firstData
  const { mediaContent } = firstData;

  // Log the mediaContent data


  return (
    <div className={styles.cointainer}>
      <div className={styles.titles}>
      <h1>{isRTL ? firstData.titleInArab : firstData.titleInEng}</h1>
      <p>{isRTL ? firstData.descriptionInArab : firstData.descriptionInEng}</p>
        </div>
      

      <div className={styles.btndiv}>
        {mediaContent.map((content, index) => (
          <button 
            key={index} 
            className={styles.btnyoutube} 
            style={{ 
              backgroundImage: `url(${content.imageUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <a href={content.instagramLink} >
              {isRTL ? content.description : content.other}
            </a>
          </button>
        ))}
      </div>
    </div>
  );
}
